import { metaKey } from '~/scripts/utils';

export default async ({ $api, $deserialize, route, store }) => {
  try {
    const data = await $api('media/guides/categories');
    store.commit('blog/setCategories', data);
  } catch (e) {
    console.error('CUSTOM_ERROR: media/guides/categories', e);
  }

  try {
    const limit = metaKey(route, 'perPage');
    const category = route.params.category;
    const page = route.query.page;

    const guidesData = await $api('media/guides', { category, limit, page });

    store.commit('blog/setGuides', guidesData);
    const breadcrumbs = [['i18n/home', '/']];
    const newMeta = { ...route.meta[0] };
    if (category) {
      const categoryData = $deserialize(store.getters['blog/getMeta'].category);
      breadcrumbs.push(['i18n/guides', '/guides/']);
      breadcrumbs.push(categoryData.description);
      newMeta.jumbotronParams = categoryData;
      newMeta.jumbotronScope = `blog.${category}`;
      newMeta.metaTagOptions = { description: categoryData.subtitle };
      newMeta.params = { ...newMeta.params, ...{ categoryData } };
    } else {
      breadcrumbs.push('i18n/guides');
    }
    newMeta.breadcrumbs = breadcrumbs;
    route.meta[0] = newMeta;
  } catch (e) {
    console.error('CUSTOM_ERROR: media/guides', e);
  }
};
